__turbopack_context__.v({
  "skipLink": "_8rcVEW_skipLink",
});
